import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import { Toast } from 'vant'
import getSignature from '@/utils/signature'
// var isLoading = false
import store from '@/store'
// import qs from 'querystringify'
const whiteList = ['/api/file/getUploadId', '/api/file/upload/single', '/api/points/my', '/api/onething/get-business-list', '/api/map/point/infos', '/api/user/profile']
const CANCEL_DUPLICATE = 'cancelRequest'
const pendingMap = new Map()
const CancelToken = axios.CancelToken

function isWhiteListed(url = '') {
  return whiteList.some((path) => url.indexOf(path) !== -1)
}

function stableStringify(value) {
  if (value == null) return ''
  if (typeof FormData !== 'undefined' && value instanceof FormData) return '[FormData]'
  if (typeof value !== 'object') return String(value)
  try {
    return JSON.stringify(value)
  } catch (e) {
    return '[Unserializable]'
  }
}

function getPendingKey(config) {
  const url = config.url || ''
  const method = (config.method || 'get').toLowerCase()
  return [method, url, stableStringify(config.params), stableStringify(config.data)].join('&')
}

function addPending(config) {
  const key = getPendingKey(config)
  config._pendingKey = key
  config.cancelToken = new CancelToken((cancel) => {
    const wrappedCancel = (message) => {
      pendingMap.delete(key)
      cancel(message)
    }
    pendingMap.set(key, wrappedCancel)
    store.commit('pushToken', { cancelToken: wrappedCancel })
  })
}

function removePending(config) {
  if (!config) return
  const key = config._pendingKey || getPendingKey(config)
  pendingMap.delete(key)
}

function clearPending(message = '路由切换取消请求') {
  const cancels = Array.from(pendingMap.values())
  pendingMap.clear()
  cancels.forEach((cancel) => {
    if (typeof cancel === 'function') cancel(message)
  })
}

function isCanceled(error) {
  return axios.isCancel(error) || (error && error.message === CANCEL_DUPLICATE)
}

window.addEventListener('popstate', function () {
  clearPending()
})

// 根据开发环境定义 baseURL
let baseURL = ''
// 如果是本地 走代理
if (process.env.NODE_ENV != 'development') {
  baseURL = process.env.VUE_APP_BASE_API
}
// 定义异步函数获取设备id
// var isInClient = typeof GSJSBridge !== 'undefined'
let deviceId = ''
// getDeviceId().then((res) => {
//   deviceId = res
// })
// async function getDeviceId() {
//   if (isInClient) {
//     let result = await new Promise((resolve, reject) => {
//       try {
//         window.GSApi.device.deviceInfo((val) => {
//           console.log(val.deviceId, '设备id')
//           if (val.deviceId) {
//             return resolve(val.deviceId)
//           } else {
//             reject()
//           }
//         })
//       } catch (error) {
//         reject()
//       }
//     })
//     return result
//   } else {
//     return ''
//   }
// }
// create an axios instance
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  // baseURL: '', // url = base url + request url
  baseURL: baseURL, // url = base url + request url
  timeout: 5 * 60 * 1000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const { method, data, contentType, url } = config
    if (url && url.indexOf('undefined') > -1) {
      console.log('参数错误：' + url)
      return Promise.reject(new Error('参数错误：' + url))
    }
    // 白名单接口允许并发；其余相同 method+url+params+data 的在途请求去重（保留旧请求）
    if (!isWhiteListed(url)) {
      const key = getPendingKey(config)
      if (pendingMap.has(key)) {
        return Promise.reject(new axios.Cancel(CANCEL_DUPLICATE))
      }
      addPending(config)
    }
    // 获得签名 signature
    var signatureObj = {}
    signatureObj = getSignature(url, method, data, config.params)
    if (process.env.NODE_ENV != 'development') {
      if (url.startsWith('/api/auth')) {
        config.baseURL = process.env.VUE_APP_BASE_API
      }
      if (url.startsWith('/api/basic')) {
        config.baseURL = process.env.VUE_APP_BASE_API
      }
    }
    // parse data
    if (contentType === 'json') {
      config.headers['Content-Type'] = 'application/json'
    } else if (method !== 'get' && _.isObject(data)) {
      if (typeof config.headers['Content-Type'] === 'undefined') {
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        // config.data = qs.stringify(data)
      }
    }
    if (method == 'get' && config.params) {
      // config.data = Object.assign(config.params, signatureObj)
      config.params = Object.assign(config.params, signatureObj)
    } else {
      config.params = signatureObj
    }
    // 签名标识头
    config.headers['X-Terminal'] = 'Wap'
    // console.log(config)
    // if (store.getters.token) {
    if (config.noNeedBearer) {
      if (sessionStorage.getItem('X-Authorization')) {
        config.headers['X-Authorization'] = sessionStorage.getItem('X-Authorization')
      }
    } else {
      if (sessionStorage.getItem('X-Authorization')) {
        config.headers['X-Authorization'] = 'Bearer ' + sessionStorage.getItem('X-Authorization')
      }
      // 这里是证件需要的请求头
      if (sessionStorage.getItem('Authorization')) {
        config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('Authorization')
      }
    }
    // 添加设备唯一标识（X-Device-Id）
    if (deviceId) {
      config.headers['X-Device-Id'] = deviceId
    }
    // }
    return config
  },
  (error) => {
    // do something with request error
    if (!isCanceled(error)) {
      console.log('---error---')
      console.log(error) // for debug
    }
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    // console.log(res, 'axios response...')
    removePending(response.config)
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      if (res.code == 411 || res.code == 412) {
        sessionStorage.removeItem('X-Authorization')
        sessionStorage.removeItem('Authorization')
        // to re-login
        window.GSApi.user.logout((val) => {
          console.log('axios response登录返回', val)
          // 登录成功
          // if (val == -1 || val == 1) {
          //   sessionStorage.setItem('X-Authorization', val)
          //   sessionStorage.setItem('Authorization', val)
          //   location.reload()
          // } else {
          //   setTimeout(() => {
          //     window.GSApi.back()
          //   }, 1000)
          // }
        })
      }
      // 512: 我的证照--未查到证件信息
      // 4006: 核酸检测不成功(人数已满、过时等)
      // 466: 核酸检测没有可预约时间段
      if (res.code == 512 || res.code == 4006 || res.code == 466) {
        return res
      }
      // 预约黑名单
      if (res.code == 10010) {
        return res
      }
      // 弹出错误提示
      // Toast(res.message)
      if (res.message !== '报名次数达到上限' && res.message) {
        Toast(res.message)
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res.data
    }
  },
  (error) => {
    removePending(error.config)
    if (isCanceled(error)) {
      return Promise.reject(error)
    }
    console.log('000000')
    console.log('超时异常error')
    console.log('err： ' + error)
    return Promise.reject(error)
  }
)
Vue.$request = service
export default service
